import React, { useEffect, useState } from 'react';
import LicenseCard from './LicenseCard';
import './css/WalletContent.css';
import authService from '../auth/authService';
import labService from '../lab/labService';
import { IoCheckmarkOutline } from 'react-icons/io5';
import payService from './payService';

const WalletContent = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [licenses, setLicenses] = useState([]);
  const [loading, setLoading] = useState(true);

  const availableOffers = [
    { id: 'one_nano', license_type: 'nano_specific', title: 'One nanoform', sub: 'specific endpoints', price: '99.00', info: 'Starts with', note: 'for one endpoint', perks: ['Test one nanoform', 'Choose only endpoints you need'] },
    { id: 'many_nano', license_type: 'many_specific', title: 'Many nanoforms', sub: 'specific endpoints', price: '499.00', info: 'Starts with', note: 'for one endpoint', perks: ['Test as many nanoforms as you want', 'Valid for 12 months'] },
    { id: 'one_nano_all', license_type: 'nano_all', title: 'One nanoform', sub: 'all endpoints', price: '2999.00', note: 'for all endpoints', perks: ['Test one nanoform', 'Test all endpoints available for one Nanoform'] },
    { id: 'substance_all', license_type: 'substance_all', title: 'One substance', sub: 'all endpoints', price: '14999.00', info: 'Starts with', perks: ['Test as many nanoforms as you want', 'Test all endpoints available for Substance'] },
  ];

  useEffect(() => {
    const user = authService.getCurrentUser();
    setCurrentUser(user);
  }, []);

  const fetchMyLicenses = async () => {
    if (!currentUser || !currentUser.access) return;

    try {
      const response = await labService.getMyLicenses(currentUser.access);
      setLicenses(response.data);
    } catch (error) {
      console.error('Error fetching my licenses:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMyLicenses();
  }, [currentUser]);

  const handlePurchase = async (license_type) => {
    try {
      const token = currentUser.access;
      console.log('Purchasing license:', license_type);
      
      // 1. Capture the response from your backend
      const response = await payService.purchaseTokens(token, license_type);

      // 2. Extract the URL
      const checkoutUrl = response.url

      // 3. Redirect the user to Stripe!
      if (checkoutUrl) {
          window.location.href = checkoutUrl; 
      } else {
          console.error('No checkout URL returned from the backend:', response);
      }

    } catch (error) {
      console.error('Error during purchase:', error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  return (
    <main className="main-wrapper">
      <div className="user-licenses">

        <header className="license-header">
          <h2 className='h2-title'>Get a new license</h2>
          <div className="status-container">
            <span className="dot" style={{ background: licenses.some(l => l.is_active) ? 'rgb(66, 161, 77)' : 'gray' }}></span>
            <p>{licenses.some(l => l.is_active) ? "You have active licenses" : "No active licenses"}</p>
          </div>
        </header>

        <div className="license-grid">
          {availableOffers.map((item) => (
            <LicenseCard
              key={item.id}
              {...item}
              buttonText="Choose"
              onChoose={() => handlePurchase(item.license_type)}
            />
          ))}

          <div className="license-card contact-card">
            <div className="card-title">
              <strong>All substances</strong> <span className="green-text">/ All endpoints</span>
            </div>
            <div className='perk-container'>
              <ul className="perk-list">
                <li><IoCheckmarkOutline className="check-icon" /> Test as many nanoforms as you want</li>
                <li><IoCheckmarkOutline className="check-icon" /> Pick from all available endpoints</li>
              </ul>
            </div>
            <div className="contact-info">
              <p><strong>Contact us to know the price!</strong></p>
              <p>+77 876 555 676, <a href="mailto:nqtb@qsarlab.com">nqtb@qsarlab.com</a></p>
            </div>
          </div>
        </div>

        <div className="table-container">
          <h3 style={{ color: '#1B4480', marginBottom: '20px', fontSize: '1.5rem', fontWeight: '700' }}>Your Active Licenses</h3>

          {loading ? (
            <p>Loading your licenses...</p>
          ) : (
            <table className="license-table">
              <thead>
                <tr>
                  <th>License Type</th>
                  <th>Purchased</th>
                  <th>Expiration</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {licenses.length === 0 ? (
                  <tr><td colSpan="4" style={{ textAlign: 'center' }}>You don't have any licenses yet.</td></tr>
                ) : (
                  licenses.map((lic) => {
                    // 1. We define the offer HERE, inside the loop, before returning the row
                    const offer = availableOffers.find(o => o.license_type === lic.license_type);

                    // 2. Now we explicitly return the JSX
                    return (
                      <tr key={lic.id} className={lic.is_active ? 'active-row' : ''}>
                        <td>
                          {lic.is_active && <div className="green-flag"></div>}
                          
                          {/* 3. Now 'offer' is defined and this will work perfectly */}
                          <strong>{offer?.title || lic.license_type}</strong><br />
                          <span className="sub-text">{offer?.sub || ''}</span>
                        </td>
                        
                        <td>{formatDate(lic.created_at)}</td>
                        <td>{formatDate(lic.expires_at)}</td>
                        
                        <td>
                          <span className={`badge ${lic.is_active ? 'active' : 'inactive'}`}>
                            {lic.is_active ? 'Active' : 'Expired'}
                          </span>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </main>
  );
};

export default WalletContent;
